import { getData} from './index';
import { FETCH_OPERATIONALSKILLSTREE, FETCH_TECHNICALSKILLSTREE, FETCH_DASHBOARD, FETCH_DASHBOARD_LIST , DASHBOARD_ERROR} from './types';


// to delete or not to delete ?
export function fetchOperationalSkillsTree() {
    const url = '/dashboard/operationalskills';
    return dispatch => getData(FETCH_OPERATIONALSKILLSTREE, DASHBOARD_ERROR, true, url, dispatch);
}

// to delete or not to delete ?
export function fetchTechnicalSkillsTree() {
    const url = '/dashboard/technicalskills';
    return dispatch => getData(FETCH_TECHNICALSKILLSTREE, DASHBOARD_ERROR, true, url, dispatch);
}

export function fetchDashboard() {
    const url = '/dashboard/';
    return dispatch => getData(FETCH_DASHBOARD, DASHBOARD_ERROR, true, url, dispatch);
}

export function getAutocompleteList() {
    const url = '/dashboard/autocompleteList'
    return dispatch => getData(FETCH_DASHBOARD_LIST, DASHBOARD_ERROR, true, url, dispatch);
  }